module.exports = __webpack_public_path__ + "static/media/flower_seller5.62e04f38.wav";